import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CommunicationMethodFormValues } from 'src/models/CommunicationMethod.model';
import CommunicationMethodForm from '../Layouts/CommunicationMethodForm';
import { useAddCommunicationMethodMutation } from 'src/services/CommunicationMethodServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddCommunicationMethodFormWrapper = ({ onClose }: Props) => { 

  const[addCommunicationMethod] = useAddCommunicationMethodMutation()
   
  // Form Initial Values
  const initialValues: CommunicationMethodFormValues = {
    communication_method :'' ,
    communication_type :''
  };

  // Validation Schema
  const validationSchema = object().shape({
    communication_method: string().required('Please enter communication method'),
    communication_type: string().required('Please enter communication type'),
  });

  // Handle Submit
  const handleSubmit = (
    values: CommunicationMethodFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CommunicationMethodFormValues>
  ) => {
    addCommunicationMethod(values).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast('error', res?.data?.message);
        }
      }
      setSubmitting(false);
    })
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CommunicationMethodForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddCommunicationMethodFormWrapper;